import {Component, Input, OnInit} from '@angular/core';
import {SearchResultEntry} from "../../../../api/models/search-result-entry";

@Component({
  selector: 'app-search-generic',
  templateUrl: './search-generic.component.html',
  styleUrls: ['./search-generic.component.scss']
})
export class SearchGenericComponent {

  @Input()
  searchResultEntry!: SearchResultEntry;

  constructor() { }

}
